
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">
              <span style={{ fontFamily: '"Pacifico", serif' }}>Patrick Segers</span>
            </h3>
            <p className="text-gray-400 mb-4">
              Especialista em investigação empresarial com foco em soluções 
              profissionais para proteger sua empresa.
            </p>
            <div className="flex space-x-4">
              <a href="https://wa.me/5511993706525" target="_blank" rel="nofollow" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
              <a href="tel:+5511993706525" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-phone-line text-xl"></i>
              </a>
              <a href="mailto:contato@detetivepatrick.com.br" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-mail-line text-xl"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="nofollow" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-xl"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Serviços</h4>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a href="#servicos" className="hover:text-white transition-colors cursor-pointer">
                  Investigação Empresarial Defensiva
                </a>
              </li>
              <li>
                <a href="#servicos" className="hover:text-white transition-colors cursor-pointer">
                  Investigação de Funcionários
                </a>
              </li>
              <li>
                <a href="#servicos" className="hover:text-white transition-colors cursor-pointer">
                  Investigação Patrimonial
                </a>
              </li>
              <li>
                <a href="#contato" className="hover:text-white transition-colors cursor-pointer">
                  Consultoria Gratuita
                </a>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Contato</h4>
            <div className="space-y-2 text-gray-400">
              <div className="flex items-center">
                <i className="ri-phone-line mr-2"></i>
                <span>(11) 99370-6525</span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line mr-2"></i>
                <span>contato@detetivepatrick.com.br</span>
              </div>
              <div className="flex items-center">
                <i className="ri-calendar-line mr-2"></i>
                <span>Seg-Sáb: 08h às 20h</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 Patrick Segers - Investigação Empresarial. Todos os direitos reservados.
          </p>
          <a 
            href="https://ovscomweb.com.br" 
            target="_blank" 
            rel="nofollow"
            className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer mt-4 md:mt-0"
          >
            OvosComWeb
          </a>
        </div>
      </div>
    </footer>
  );
}
